import { GAME_FACT_BASKET_STOP, GAME_FACT_HANDBALL_STOP, GAME_FACT_RUGBY_STOP, GAME_FACT_SOCCER_STOP, GAME_FACT_START } from "./types";

export const START_STOP_PERIODS_EVENTS_LABELS = {
  soccer: [
    { type: GAME_FACT_START, label: "DEBUT DE PERIODE" },
    { type: GAME_FACT_SOCCER_STOP, label: "FIN DE PERIODE" },
  ],
  rugby: [
    { type: GAME_FACT_START, label: "DEBUT DE PERIODE" },
    { type: GAME_FACT_RUGBY_STOP, label: "FIN DE PERIODE" },
  ],
  handball: [
    { type: GAME_FACT_START, label: "DEBUT DE PERIODE" },
    { type: GAME_FACT_HANDBALL_STOP, label: "FIN DE PERIODE" },
  ],
  basket: [
    { type: GAME_FACT_START, label: "DEBUT DE QUART TEMPS" },
    { type: GAME_FACT_BASKET_STOP, label: "FIN DE QUART TEMPS" },
  ]
}